import styled from 'styled-components'

import { TypeStyle, fromMd, timingDefault, zIndexForeground } from '@syconium/little-miss-figgy'

import { ModalCloseButton } from '../../../brunswick/components/ModalCloseButton'
import { NextModalStyles } from '../NextModal'

export const modalStyles: NextModalStyles = {
  content: {
    borderRadius: 0,
    borderWidth: 0,
    bottom: 'initial',
    boxSizing: 'border-box',
    left: 'initial',
    overflow: 'initial',
    padding: 'initial',
    position: 'initial',
    right: 'initial',
    top: 'initial',
    width: '960px',
  },
  overlay: {
    backgroundColor: undefined,
  },
}

export const Body = styled.div`
  overflow: auto;
`

export const Header = styled.header`
  box-sizing: border-box;
  align-items: center;
  background-color: white;
  display: flex;
  justify-content: center;
  line-height: 26px;
  padding: ${o => o.theme.spacing(4, 4)};
  position: sticky;
  top: 0;
  z-index: ${zIndexForeground};
  min-height: 0;

  ${fromMd} {
    padding: ${o => o.theme.spacing(5, 4)};
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  ${fromMd} {
    flex-direction: row;
    height: 550px;
  }
`

export const TextWrapper = styled.div`
  flex: 1;

  ${fromMd} {
    overflow-y: auto;
    padding: 0 40px;
  }
`

export const ImageWrapper = styled.div`
  flex: 1;

  ${fromMd} {
    margin-top: 0;
    margin-bottom: 40px;

    margin-inline-start: 40px;
    margin-inline-end: 0;
  }
`

export const Summary = styled.div`
  padding: 16px;

  ${fromMd} {
    padding: 0;
  }
`

export const FullDetailsButton = styled(TypeStyle.HeadlineExtraExtraSmall)`
  display: inline-block;
  margin: 12px 0;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    transition: color ${timingDefault};
    opacity: 0.8;
  }

  ${fromMd} {
    margin: 16px 0 32px;
  }
`

export const ModalDismiss = styled(ModalCloseButton)`
  position: relative;
  padding: 0;
  justify-self: flex-end;
  align-self: flex-end;
  margin-left: auto;
  ${fromMd} {
    position: absolute;
    top: ${o => o.theme.spacing(5)};
    right: ${o => o.theme.spacing(5)};
    padding: 0;
    height: auto;
  }
`
